export type Locale = "da" | "en";

export const defaultLocale: Locale = "da";

export const localeLabels: Record<Locale, string> = {
  da: "Dansk",
  en: "English",
};

export const translations: Record<Locale, Record<string, string>> = {
  da: {
    "app.loadingData": "Indlæser data...",
    "app.openPage": "Åbn side",
    "app.selectPage": "Vælg en side for at komme i gang.",
    "app.welcome": "Velkommen",
    "auth.backToSignIn": "Tilbage til log ind",
    "auth.createAccount": "Opret konto",
    "auth.email": "E-mail",
    "auth.emailPlaceholder": "dig@example.com",
    "auth.enterVerification": "Indtast bekræftelseskode",
    "auth.forgotPassword": "Glemt adgangskode?",
    "auth.haveAccount": "Har du allerede en konto?",
    "auth.loadingSession": "Indlæser session...",
    "auth.name": "Navn",
    "auth.namePlaceholder": "Navn",
    "auth.needAccount": "Har du ikke en konto?",
    "auth.newPassword": "Ny adgangskode",
    "auth.password": "Adgangskode",
    "auth.passwordPlaceholder": "••••••••",
    "auth.rememberedPassword": "Kan du huske din adgangskode?",
    "auth.resetComplete": "Adgangskode nulstillet. Du kan logge ind nu.",
    "auth.resetEmailSent": "Tjek din e-mail for bekræftelseskoden.",
    "auth.resetPassword": "Nulstil adgangskode",
    "auth.sendCode": "Send kode",
    "auth.signIn": "Log ind",
    "auth.signOut": "Log ud",
    "auth.signUp": "Opret konto",
    "auth.verificationCode": "Bekræftelseskode",
    "auth.verificationPlaceholder": "123456",
    "auth.working": "Arbejder...",
    "bankAccounts.add": "Tilføj bankkonto",
    "bankAccounts.confirmDelete": "Slet denne konto? Dette kan ikke fortrydes.",
    "bankAccounts.currency": "Valuta",
    "bankAccounts.currencyPlaceholder": "Valuta",
    "bankAccounts.empty": "Ingen konti endnu.",
    "bankAccounts.manageSubtitle": "Tilføj eller fjern bankkonti for dette hus.",
    "bankAccounts.manageTitle": "Administrer bankkonti",
    "bankAccounts.name": "Navn",
    "bankAccounts.namePlaceholder": "Kontonavn",
    "bankAccounts.number": "Nummer",
    "bankAccounts.numberPlaceholder": "Kontonummer",
    "bankAccounts.readonly": "Dette hus er skrivebeskyttet. Kun fuld adgang kan administrere bankkonti.",
    "bankAccounts.removeFailed": "Kunne ikke fjerne konto",
    "bankAccounts.required": "Navn, kontonummer og valuta er påkrævet.",
    "bankAccounts.saveFailed": "Kunne ikke gemme konto",
    "accounts.title": "Kontoplan",
    "accounts.subtitle": "Gennemgå saldi og gå til kontoens posteringer.",
    "accounts.selectHouse": "Vælg et hus for at se kontoplanen.",
    "accounts.loading": "Indlæser konti...",
    "accounts.loadFailed": "Kunne ikke indlæse konti",
    "accounts.listTitle": "Konti",
    "accounts.noChart": "Ingen kontoplan data tilgængelig.",
    "accounts.empty": "Ingen konti konfigureret endnu.",
    "accounts.account": "Konto",
    "accounts.name": "Navn",
    "accounts.balance": "Saldo",
    "bankTransactions.amount": "Beløb",
    "bankTransactions.amountChannel": "Beløb: {amount} · Kanal: Banktransaktion",
    "bankTransactions.amountGreaterThanZero": "Beløbet skal være større end nul.",
    "bankTransactions.amountSameSign": "Beløbet skal have samme fortegn som transaktionen.",
    "bankTransactions.bankAccount": "Bankkonto",
    "bankTransactions.channel": "Kanal",
    "bankTransactions.channelBalance": "Kanal: {channel} · Saldo: {balance}",
    "bankTransactions.channelNotDetected": "Kanalen kunne ikke genkendes fra transaktionen.",
    "bankTransactions.channelNotDetectedDescription": "Ingen kanal fundet i banktransaktionens beskrivelse.",
    "bankTransactions.channelValue": "Banktransaktion",
    "bankTransactions.chooseAccount": "Vælg en konto for at se transaktioner.",
    "bankTransactions.column": "Kolonne {index}",
    "bankTransactions.confirmRemove": "Fjern kobling?",
    "bankTransactions.createEntryFailed": "Kunne ikke oprette postering.",
    "bankTransactions.csvFile": "CSV-fil",
    "bankTransactions.description": "Beskrivelse",
    "bankTransactions.detectedAmountFormat": "Registreret beløbsformat: {format}",
    "bankTransactions.detectedDateFormat": "Registreret datoformat: {format}",
    "bankTransactions.detectedDelimiter": "Registreret separator: {delimiter}",
    "bankTransactions.empty": "Ingen transaktioner tilgængelige.",
    "bankTransactions.exceedsRemaining": "Beløbet overstiger restbeløbet.",
    "bankTransactions.fieldMapping": "Feltkobling",
    "bankTransactions.hasHeader": "Filen indeholder overskriftsrække",
    "bankTransactions.importFailed": "Import mislykkedes",
    "bankTransactions.importReadonly": "Dette hus er skrivebeskyttet. Import er deaktiveret.",
    "bankTransactions.importSelectHouse": "Vælg et hus for at importere transaktioner.",
    "bankTransactions.importSettings": "Importindstillinger",
    "bankTransactions.importSubtitle": "Upload en CSV-eksport og tilknyt kolonnerne.",
    "bankTransactions.importTitle": "Importer transaktioner",
    "bankTransactions.importTransactions": "Importer transaktioner",
    "bankTransactions.importedRows": "Importerede {inserted} af {total} rækker.",
    "bankTransactions.importing": "Importerer...",
    "bankTransactions.inventoryLoadFailed": "Kunne ikke indlæse lager",
    "bankTransactions.link": "Afstemning",
    "bankTransactions.linkAllocation": "Tildelt: {assigned} · Rest: {remaining} · Saldo brugt: {balanceApplied} · Tilgængelig: {available}",
    "bankTransactions.linkFailed": "Kunne ikke koble tilgodehavender.",
    "bankTransactions.linkReadonly": "Dette hus er skrivebeskyttet. Afstemning er deaktiveret.",
    "bankTransactions.linkSelected": "Afstem valgte",
    "bankTransactions.linkSummary": "Beløb: {amount} · Afstemt: {linked} · Rest: {remaining}",
    "bankTransactions.linkTabs": "Afstemningsfaner",
    "bankTransactions.linkTitle": "Afstem transaktion",
    "bankTransactions.linkedAmount": "Afstemt {amount}",
    "bankTransactions.linkStatus.linked": "Afstemt",
    "bankTransactions.linkStatus.partial": "Delvist afstemt",
    "bankTransactions.linkStatus.unlinked": "Ikke afstemt",
    "bankTransactions.linksLoadFailed": "Kunne ikke indlæse afstemninger",
    "bankTransactions.linksTab": "Afstemninger",
    "bankTransactions.loadAccountsFailed": "Kunne ikke indlæse konti",
    "bankTransactions.loadFailed": "Kunne ikke indlæse transaktioner",
    "bankTransactions.loadingAccounts": "Indlæser konti...",
    "bankTransactions.loadingTransactions": "Indlæser transaktioner...",
    "bankTransactions.mapFields": "Kobl dato, beskrivelse og beløb for at fortsætte.",
    "bankTransactions.mapFieldsHint": "Upload en CSV-fil for at koble felter.",
    "bankTransactions.manageAccounts": "Administrer bankkonti",
    "bankTransactions.missingDate": "Transaktionen mangler dato.",
    "bankTransactions.noLinks": "Ingen koblinger endnu.",
    "bankTransactions.noReceivables": "Ingen tilgodehavende posteringer til kobling.",
    "bankTransactions.noSmartLink": "Ingen præcis smart-kobling fundet.",
    "bankTransactions.noUnsettled": "Ingen uafregnede posteringer fundet.",
    "bankTransactions.notDetected": "Ikke fundet",
    "bankTransactions.positiveOnly": "Kun positive transaktioner kan kobles til tilgodehavender.",
    "bankTransactions.readonly": "Dette hus er skrivebeskyttet. Bankkonti og sammenkædning er deaktiveret.",
    "bankTransactions.receivableLinks": "Tilgodehavender",
    "bankTransactions.reconcile": "Afstem",
    "bankTransactions.remaining": "Rest",
    "bankTransactions.removeLinkFailed": "Kunne ikke fjerne kobling.",
    "bankTransactions.selectBankAccount": "Vælg bankkonto",
    "bankTransactions.selectColumn": "Vælg kolonne",
    "bankTransactions.selectReceivable": "Vælg mindst én tilgodehavende postering.",
    "bankTransactions.selectionExceeds": "Valget overstiger tilgængeligt beløb inkl. kanalsaldo.",
    "bankTransactions.smartLink": "Smart-afstemning",
    "bankTransactions.subtitle": "Importer og gennemgå bankudskrifter.",
    "bankTransactions.suggestionsLoadFailed": "Kunne ikke indlæse forslag",
    "bankTransactions.tab": "Tabulator",
    "bankTransactions.title": "Banktransaktioner",
    "bankTransactions.transactions": "Transaktioner",
    "bankTransactions.validAmount": "Angiv et gyldigt beløb.",
    "bookings.days": "Dage",
    "bookings.daysBooked": "{count} dage booket",
    "bookings.dates": "Datoer",
    "bookings.empty": "Ingen bookinger for det valgte år.",
    "bookings.fullWeek": "Fuld uge",
    "bookings.fullWeeks": "Fuld uger",
    "bookings.fullWeeksLeft": "Fuld uger tilbage",
    "bookings.inventoryLoading": "Indlæser lager...",
    "bookings.inventoryTitle": "Lager / Ubooket",
    "bookings.listTitle": "Bookingsliste",
    "bookings.loadFailed": "Kunne ikke indlæse bookinger",
    "bookings.monthSummary": "{booked} dage booket - {available} tilbage",
    "bookings.monthlyCoverage": "Månedlig dækning",
    "bookings.noAvailability": "Ingen tilgængelighed endnu.",
    "bookings.noBookings": "Ingen bookinger",
    "bookings.noFullWeeks": "Ingen fulde uger tilbage.",
    "bookings.noInventory": "Ingen lagerdata endnu.",
    "bookings.noMonthlyCoverage": "Ingen månedlig dækning endnu.",
    "bookings.noWeekends": "Ingen weekender tilbage.",
    "bookings.period": "Periode",
    "bookings.price": "Pris",
    "bookings.selectHouse": "Vælg et hus for at se bookinger.",
    "bookings.status": "Status",
    "bookings.subtitle": "Samlede bookinger på tværs af kanaler.",
    "bookings.title": "Bookinger",
    "bookings.totalRevenue": "Samlet indtægt",
    "bookings.totalValue": "Samlet værdi",
    "bookings.totals": "Total",
    "bookings.utilitiesRevenue": "Forbrugsindtægt",
    "bookings.week": "Uge",
    "bookings.weekLabel": "Uge {week}",
    "bookings.weekOverview": "Ugeoversigt",
    "bookings.weekValue": "U{week}",
    "bookings.weekdays": "Hverdage",
    "bookings.weekend": "Weekend",
    "bookings.weekends": "Weekender",
    "bookings.weekendsLeft": "Weekender tilbage",
    "bookings.missingPrices": "Manglende priser for {count} perioder.",
    "bookings.loading": "Indlæser bookinger...",
    "bookings.inventoryLoadFailed": "Kunne ikke indlæse lager",
    "chart.account.bankLoanInterest": "Banklånsrenter",
    "chart.account.bankLoanPrincipal": "Afdrag på banklån",
    "chart.account.cashAndChannelBalances": "Kontant og kanalsaldi",
    "chart.account.cashOnHand": "Kontantbeholdning",
    "chart.account.ebit": "EBIT",
    "chart.account.holidayHomeTax": "Skat af sommerhusudlejning",
    "chart.account.insuranceExpenses": "Forsikringsomkostninger",
    "chart.account.internetSubscriptions": "Internet- og TV-abonnementer",
    "chart.account.liquidityDeposit": "Likviditetsindskud",
    "chart.account.liquidityResult": "Likviditetsresultat",
    "chart.account.liquidityWithdrawal": "Likviditetsudtræk",
    "chart.account.ownerMovements": "Ejerbevægelser",
    "chart.account.netLiquidityChange": "Netto likviditetsændring",
    "chart.account.maintenanceRepairs": "Vedligehold og reparationer",
    "chart.account.miscExpenses": "Diverse omkostninger",
    "chart.account.mortgageInterest": "Realkreditrenter",
    "chart.account.mortgagePrincipal": "Afdrag på realkredit",
    "chart.account.propertyTax": "Ejendomsskat",
    "chart.account.propertyValueTax": "Ejendomsværdiskat",
    "chart.account.rentalProfit": "Udlejningsresultat",
    "chart.account.totalExpenses": "Samlede omkostninger",
    "chart.account.operatingExpenses": "Driftsomkostninger",
    "chart.account.totalInterestExpense": "Samlede renteomkostninger",
    "chart.account.totalRentalIncome": "Samlet lejeindtægt",
    "chart.account.totalRevenue": "Samlet omsætning",
    "chart.account.totalUtilityExpenses": "Samlede forbrugsomkostninger",
    "chart.account.totalUtilityIncome": "Samlet forbrugsindtægt",
    "chart.account.utilityExpenses.electricity": "Forbrugsomkostninger - El",
    "chart.account.utilityExpenses.heating": "Forbrugsomkostninger - Varme",
    "chart.account.utilityExpenses.water": "Forbrugsomkostninger - Vand",
    "chart.account.utilityIncome.electricity": "Forbrugsindtægt - El",
    "chart.account.utilityIncome.heating": "Forbrugsindtægt - Varme",
    "chart.account.utilityIncome.water": "Forbrugsindtægt - Vand",
    "chart.account.balance.villavilla": "Kanalsaldo - VillaVilla",
    "chart.account.balance.admiralstrand": "Kanalsaldo - Admiral Strand",
    "chart.account.income.villavilla": "Lejeindtægt - VillaVilla",
    "chart.account.income.admiralstrand": "Lejeindtægt - Admiral Strand",
    "common.cancel": "Annuller",
    "common.close": "Luk",
    "common.closeNotification": "Luk notifikation",
    "common.date": "Dato",
    "common.deleting": "Sletter...",
    "common.edit": "Rediger",
    "common.loading": "Indlæser...",
    "common.remove": "Fjern",
    "common.removing": "Fjerner...",
    "common.saving": "Gemmer...",
    "common.year": "År",
    "environment.dev": "Udvikling",
    "environment.staging": "Staging",
    "entries.account": "Konto",
    "entries.all": "Alle",
    "entries.audit": "Revision",
    "entries.auditEmpty": "Ingen revisionshistorik endnu.",
    "entries.auditLoadFailed": "Kunne ikke indlæse revision",
    "entries.auditLoading": "Indlæser revision...",
    "entries.auditTitle": "Revisionslog",
    "entries.change": "Ændring",
    "entries.channelPlaceholder": "Faktura, manuel, osv.",
    "entries.createTitle": "Opret postering",
    "entries.editTitle": "Rediger postering",
    "entries.empty": "Ingen posteringer for de valgte filtre.",
    "entries.delete": "Slet postering",
    "entries.deleteConfirm": "Slet denne postering? Dette kan ikke fortrydes.",
    "entries.deleteFailed": "Kunne ikke slette postering",
    "entries.forAccount": "Posteringer for {name}.",
    "entries.journalDate": "Bogføringsdato",
    "entries.ledgerType": "Bogføringstype",
    "entries.loadFailed": "Kunne ikke indlæse posteringer",
    "entries.new": "Ny postering",
    "entries.noAccount": "Ingen konto",
    "entries.notes": "Noter",
    "entries.notesPlaceholder": "Valgfrie noter",
    "entries.readonly": "Dette hus er skrivebeskyttet. Ændringer i posteringer er deaktiveret.",
    "entries.readonlyCreate": "Dette hus er skrivebeskyttet. Oprettelse af posteringer er deaktiveret.",
    "entries.required": "Bogføringsdato og beløb er påkrævet.",
    "entries.amountSignWarning": "Advarsel: Beløbets fortegn ser usædvanligt ud for {account}. Fortsæt alligevel?",
    "entries.save": "Gem postering",
    "entries.saveFailed": "Kunne ikke gemme postering",
    "entries.selectHouse": "Vælg et hus for at administrere posteringer.",
    "entries.subtitle": "Opret, rediger og gennemgå posteringer.",
    "entries.title": "Posteringer",
    "entries.unknown": "Ukendt",
    "entries.user": "Bruger",
    "errors.loadData": "Kunne ikke indlæse data",
    "house.bookingWeek": "Bookinguge",
    "house.bookingWeekDescription": "Vælg ugeafgrænsning for oversigter.",
    "house.create": "Opret hus",
    "house.createDescription": "Opret huset først og tilslut derefter bookingkanaler.",
    "house.createFailed": "Kunne ikke oprette",
    "house.delete": "Slet hus",
    "house.deleteConfirmPrefix": "Skriv",
    "house.deleteConfirmSuffix": "for at bekræfte.",
    "house.deleteFailed": "Kunne ikke slette huset",
    "house.deletePlaceholder": "Skriv \"{houseName}\" for at bekræfte",
    "house.deleteWarning": "Sletning af et hus fjerner alle tilknyttede data. Dette kan ikke fortrydes.",
    "house.dangerZone": "Farezone",
    "house.nameLabel": "Husnavn",
    "house.namePlaceholder": "Kysthytte",
    "house.nameRequired": "Husnavn er påkrævet.",
    "house.noHouses": "Ingen huse endnu",
    "house.noHousesDescription": "Opret et hus for at komme i gang.",
    "house.readonly": "Dette hus er skrivebeskyttet. Du kan se importlog, men kun brugere med fuld adgang kan ændre indstillinger eller administrere adgang.",
    "house.selectLabel": "Hus",
    "house.selectPlaceholder": "Vælg hus",
    "house.weekFriday": "Fredag -> Fredag",
    "house.weekSaturday": "Lørdag -> Lørdag",
    "house.weekUpdateFailed": "Kunne ikke opdatere bookinguge",
    "imports.channel": "Kanal",
    "imports.empty": "Ingen importer logget endnu.",
    "imports.error": "Fejl",
    "imports.kind": "Type",
    "imports.recent": "Seneste importer",
    "imports.started": "Startet",
    "imports.status": "Status",
    "imports.title": "Importlog",
    "invite.accept": "Acceptér",
    "invite.acceptFailed": "Kunne ikke acceptere",
    "invite.accepting": "Accepterer...",
    "invite.email": "E-mail",
    "invite.emailPlaceholder": "bruger@example.com",
    "invite.failed": "Kunne ikke invitere",
    "invite.full": "Fuld adgang",
    "invite.pending": "Afventende invitationer",
    "invite.pendingHouseInvites": "Afventende husinvitationer",
    "invite.readonly": "Skrivebeskyttet",
    "invite.revoke": "Tilbagekald",
    "invite.roleLabel": "Rolle",
    "invite.send": "Send invitation",
    "invite.title": "Inviter bruger",
    "access.current": "Nuværende adgang",
    "access.user": "Bruger",
    "access.role": "Rolle",
    "access.remove": "Fjern",
    "channels.connect": "Tilslut",
    "channels.connectTitle": "Tilslut {channel}",
    "channels.disconnect": "Afbryd",
    "channels.runImport": "Kør import",
    "channels.saveFailed": "Kunne ikke gemme",
    "channels.verifying": "Bekræfter...",
    "channels.eloverblikTokenHelp":
      "Hent din refresh token fra trin 1 i ElOverblik Customer-guiden, og indsæt den her.",
    "channels.eloverblikGuide": "Åbn guide",
    "channels.eloverblikRefreshToken": "Refresh token",
    "channels.eloverblikFindMeteringPoints": "Find huse",
    "channels.eloverblikSaveSelection": "Gem valg",
    "channels.eloverblikMeteringPoint": "Målepunkt",
    "channels.admiralstrandHouseId": "Hus-ID",
    "ledger.actual": "Faktisk",
    "ledger.budget": "Budget",
    "ledger.forecast": "Forecast",
    "nav.admin": "Admin",
    "nav.adminDescription": "Se systemstatistik og aktivitet.",
    "nav.balanceSheet": "Balance",
    "nav.balanceSheetDescription": "Se aktivbalancer over tid.",
    "nav.bankTransactions": "Banktransaktioner",
    "nav.bankTransactionsDescription": "Importer og gennemgå bankudtog.",
    "nav.dashboard": "Dashboard",
    "nav.dashboardDescription": "Hurtigt overblik over det der kræver opmærksomhed.",
    "nav.bookings": "Bookinger",
    "nav.bookingsDescription": "Se samlede bookinger, uger og måneder.",
    "nav.chartOfAccounts": "Kontoplan",
    "nav.chartOfAccountsDescription": "Se kontostruktur og saldi.",
    "nav.journalEntries": "Posteringer",
    "nav.journalEntriesDescription": "Opret og gennemgå posteringer, budget og forecast.",
    "nav.meterReadings": "Måleraflæsninger",
    "nav.meterReadingsDescription": "Gennemgå og valider el- og vandaflæsninger.",
    "nav.profitLoss": "Resultatopgørelse",
    "nav.profitLossDescription": "Sammenlign faktiske, budget, forecast og sidste år.",
    "nav.budgetWorksheet": "Budget",
    "nav.budgetWorksheetDescription": "Rediger flerårige budgetter i et gitter.",
    "nav.receivables": "Tilgodehavender",
    "nav.receivablesDescription": "Følg kanalers tilgodehavender og afregning.",
    "nav.settings": "Indstillinger",
    "nav.settingsDescription": "Administrer huse og adgang.",
    "nav.statistics": "Statistik",
    "nav.statisticsDescription": "Gennemgå bookingperformance og indtægter.",
    "nav.consumption": "Forbrug",
    "nav.consumptionDescription": "Analyser el- og vandforbrug pr. dag.",
    "navGroup.accounting": "Regnskab",
    "navGroup.admin": "Admin",
    "navGroup.bookings": "Bookinger og rapporter",
    "navGroup.waterElectricity": "Vand og el",
    "navGroup.settings": "Indstillinger",
    "consumption.title": "Forbrug",
    "consumption.subtitle":
      "Betalt-afledt forbrug er primær kilde og sammenlignes med ElOverblik når muligt.",
    "consumption.selectHouse": "Vælg et hus for at se forbrug.",
    "consumption.loading": "Indlæser forbrug...",
    "consumption.loadFailed": "Kunne ikke indlæse forbrugsdata",
    "consumption.electricity": "El",
    "consumption.water": "Vand",
    "consumption.electricityPerDay": "El pr. dag",
    "consumption.waterPerDay": "Vand pr. dag",
    "consumption.readingsTable": "Måleraflæsninger",
    "consumption.date": "Dato",
    "consumption.noReadings": "Ingen aflæsninger tilgængelige.",
    "consumption.periodsTable": "Forbrugsperioder",
    "consumption.period": "Periode",
    "consumption.noPeriods": "Ingen forbrugsperioder tilgængelige.",
    "consumption.comparisonTable": "Booking sammenligning (Betalt-afledt vs ElOverblik)",
    "consumption.comparisonMissingSetup":
      "Forbind ElOverblik i Indstillinger og vælg et målepunkt for at sammenligne værdier.",
    "consumption.booking": "Booking",
    "consumption.meterKwh": "Måler (kWh)",
    "consumption.inferredKwh": "Udledt (kWh)",
    "consumption.paidForDerived": "Betalt for",
    "consumption.eloverblikMeasured": "ElOverblik målt",
    "consumption.usagePerDay": "Forbrug/dag",
    "consumption.eloverblikKwh": "ElOverblik (kWh)",
    "consumption.deviationPercent": "Afvigelse %",
    "consumption.deviationDkk": "Afvigelse DKK",
    "consumption.warning": "Advarsel",
    "consumption.warningOver20": "Over 20%",
    "consumption.warningOk": "OK",
    "consumption.noComparisonRows": "Der er endnu ingen booking-baserede sammenligningsrækker.",
    "consumption.inBetweenTable": "Mellemperioder (ikke-booket)",
    "consumption.noInBetweenRows": "Ingen mellemperioder fundet i valgt interval.",
    "meterReadings.title": "Forbrugsoversigt",
    "meterReadings.subtitle":
      "Sammenlign betalt forbrug med rapporterede aflæsninger og ElOverblik.",
    "meterReadings.selectHouse": "Vælg et hus for at se måleraflæsninger.",
    "meterReadings.loading": "Indlæser...",
    "meterReadings.loadFailed": "Kunne ikke indlæse måleraflæsninger",
    "meterReadings.saveFailed": "Kunne ikke gemme måleraflæsninger",
    "meterReadings.include": "Medtag",
    "meterReadings.resetAuto": "Brug auto",
    "meterReadings.excludedReason": "Udeladt: {reason}",
    "meterReadings.excludedMonotonic": "Udeladt: start {start} < forrige {prev}",
    "meterReadings.newMeterLabel": "Ny måler installeret",
    "meterReadings.newMeterHelp": "Aflæsninger efter dette punkt behandles som en ny start.",
    "meterReadings.addNewMeter": "Tilføj ny målerhændelse",
    "meterReadings.removeNewMeter": "Fjern ny målerhændelse",
    "meterReadings.startReading": "Startaflæsning",
    "meterReadings.endReading": "Slutaflæsning",
    "meterReadings.override": "Overskriv",
    "meterReadings.noPairs": "Ingen aflæsninger endnu.",
    "meterReadings.date": "Dato",
    "meterReadings.reportedValue": "Rapporteret værdi",
    "meterReadings.overrideValue": "Overskrevet værdi",
    "meterReadings.inferredFromRevenue": "Udledt fra forbrugsindtægt",
    "meterReadings.derivedUsage": "Betalt-afledt forbrug",
    "meterReadings.paidForUsage": "Betalt {dkk} DKK for forbrug {usage} {unit}",
    "meterReadings.derivedUsagePerDay": "Forbrug pr. dag: {value} {unit}",
    "meterReadings.eloverblikUsage": "ElOverblik forbrug: {value} kWh",
    "meterReadings.newMeterQuestion": "Ny måler installeret?",
    "meterReadings.readingStart": "Aflæsning start",
    "meterReadings.readingEnd": "Aflæsning slut",
    "meterReadings.calculatedSuffix": "(beregnet)",
    "meterReadings.reportedReadings": "rapporterede aflæsninger",
    "meterReadings.overviewTitle": "Booking forbrugsoversigt",
    "meterReadings.noOverviewRows": "Ingen bookingoversigt-rækker tilgængelige.",
    "meterReadings.costDkk": "Omkostning (DKK)",
    "meterReadings.costPerDayDkk": "Omkostning/dag (DKK)",
    "meterReadings.days": "Dage",
    "meterReadings.total": "I alt",
    "meterReadings.dayShort": "dag",
    "meterReadings.reportedUsage": "Rapporteret (m3)",
    "meterReadings.rawParsedReadings": "Rå parsed aflæsninger",
    "meterReadings.parsedStart": "Parsed aflæsning start",
    "meterReadings.parsedEnd": "Parsed aflæsning slut",
    "meterReadings.derivedStart": "Afledt start",
    "meterReadings.derivedEnd": "Afledt slut",
    "meterReadings.noManual": "Ingen manuelle aflæsninger endnu.",
    "meterReadings.electricity": "El",
    "meterReadings.water": "Vand",
    "meterReadings.manualTitle": "Tilføj manuel aflæsning",
    "meterReadings.value": "Værdi",
    "meterReadings.notes": "Noter",
    "meterReadings.manualTypeLabel": "Tilføjer til {type}",
    "meterReadings.addManual": "Tilføj manuel aflæsning",
    "meterReadings.manualReadings": "Manuelle aflæsninger",
    "meterReadings.invalidManual": "Angiv en dato og en numerisk værdi.",
    "meterReadings.resetCreateFailed": "Kunne ikke tilføje ny målerhændelse",
    "meterReadings.resetRemoveFailed": "Kunne ikke fjerne målerhændelse",
    "meterReadings.complaintTooltip": "Write complaint to agency",
    "meterReadings.complaintButtonTitle": "Skriv klage",
    "meterReadings.complaintModalTitle": "Klage-e-mail kladde",
    "meterReadings.complaintChannelLabel": "Bureau",
    "meterReadings.complaintStartDateLabel": "Startdato",
    "meterReadings.complaintEndDateLabel": "Slutdato",
    "meterReadings.complaintThresholdLabel": "Bagatelgrænse (DKK)",
    "meterReadings.complaintLanguageLabel": "Sprog",
    "meterReadings.complaintLanguageDanish": "Dansk",
    "meterReadings.complaintLanguageEnglish": "Engelsk",
    "meterReadings.complaintIncludeCleaningReading": "Include \"rengøring kWh\" column.",
    "meterReadings.complaintSummary": "{count} bookinger, samlet underbetaling {amount} DKK",
    "pagination.pageOf": "Side {current} af {total}",
    "pagination.previous": "Forrige",
    "pagination.next": "Næste",
    "pagination.showing": "Viser {start}-{end} af {total}",
    "reports.assets": "Aktiver",
    "reports.balanceSheetSelectHouse": "Vælg et hus for at se balancen.",
    "reports.balanceSheetTitle": "Balance",
    "reports.balanceSheetAsOf": "Aktivbalancer pr. {date}.",
    "reports.loading": "Indlæser rapport...",
    "reports.noAssetAccounts": "Ingen aktivkonti konfigureret endnu.",
    "reports.noData": "Ingen rapportdata.",
    "reports.noProfitLossAccounts": "Ingen resultatkonti konfigureret endnu.",
    "reports.profitLossSelectHouse": "Vælg et hus for at se resultatopgørelsen.",
    "reports.profitLossSubtitle": "Sammenlign faktiske, budget, forecast og sidste år.",
    "reports.profitLossTitle": "Resultatopgørelse",
    "reports.actual": "Faktisk",
    "reports.actualYear": "Faktisk år",
    "reports.budgetWorksheetTitle": "Budgetark",
    "reports.budgetWorksheetSubtitle": "Rediger fire års budgetter og kopier/indsæt fra Excel.",
    "reports.budgetWorksheetSelectHouse": "Vælg et hus for at redigere budgetter.",
    "reports.budgetWorksheetLoadFailed": "Kunne ikke indlæse budgetarket",
    "reports.budgetStartYear": "Startår",
    "reports.budgetWorksheetTableTitle": "Budgetgitter",
    "reports.budgetWorksheetPasteHint": "Indsæt en TSV-blok for at udfylde celler.",
    "reports.copyTsv": "Kopiér som TSV",
    "reports.copyTsvSuccess": "Tabellen er kopieret til udklipsholderen.",
    "reports.copyTsvFailed": "Kunne ikke kopiere til udklipsholderen.",
    "reports.saveBudget": "Gem budget",
    "reports.savingBudget": "Gemmer...",
    "reports.budgetWorksheetSaved": "Budgetter gemt.",
    "reports.budgetWorksheetSaveFailed": "Kunne ikke gemme budgetter.",
    "reports.invalidBudgetInput": "Angiv gyldige tal før du gemmer.",
    "reports.budgetReadonly": "Budgetter er skrivebeskyttede for dette hus.",
    "reports.results": "Resultater",
    "reports.selectedPeriod": "den valgte periode",
    "reports.actualYtd": "Faktisk YTD",
    "reports.budget": "Budget",
    "reports.forecast": "Forecast",
    "reports.lastYear": "Sidste år",
    "receivables.bookingId": "Booking-id",
    "receivables.created": "Oprettet",
    "receivables.empty": "Ingen tilgodehavender for de valgte filtre.",
    "receivables.listTitle": "Tilgodehavendeliste",
    "receivables.loadFailed": "Kunne ikke indlæse tilgodehavender",
    "receivables.loading": "Indlæser tilgodehavender...",
    "receivables.outstandingTotal": "Udestående i alt",
    "receivables.selectHouse": "Vælg et hus for at se tilgodehavender.",
    "receivables.settled": "Afregnet",
    "receivables.status": "Status",
    "receivables.subtitle": "Følg tilgodehavender og afregning.",
    "receivables.title": "Tilgodehavender",
    "receivables.unsettled": "Uafregnet",
    "dashboard.title": "Dashboard",
    "dashboard.subtitle": "Overblik over integrationer, bookinger, tilgodehavender og bankopfølgning.",
    "dashboard.selectHouse": "Vælg et hus for at se dashboardet.",
    "dashboard.loading": "Indlæser dashboard...",
    "dashboard.loadFailed": "Kunne ikke indlæse dashboard",
    "dashboard.integration.title": "Integrationsstatus",
    "dashboard.integration.missing": "Manglende opsætning for {count} kanal(er).",
    "dashboard.integration.setupHint":
      "Åbn Indstillinger, forbind de manglende kanaler og kør en import for at initialisere data.",
    "dashboard.integration.failed": "Seneste import fejlede for {count} kanal(er).",
    "dashboard.integration.lastJob": "Job: {kind} kl. {time}",
    "dashboard.integration.unknownError": "Ukendt importfejl.",
    "dashboard.integration.loading": "Indlæser integrationsstatus...",
    "dashboard.integration.openSettings": "Åbn indstillinger",
    "dashboard.bookings.title": "Bookede dage og omsætning pr. måned",
    "dashboard.bookings.subtitle": "Bookede dage (venstre akse) og omsætning DKK (højre akse).",
    "dashboard.bookings.empty": "Ingen bookingdata for det valgte år.",
    "dashboard.bookings.bookedDays": "Bookede dage",
    "dashboard.bookings.revenue": "Udlejningsomsætning DKK",
    "dashboard.deviation.title": "Store forbrugsafvigelser",
    "dashboard.deviation.subtitle":
      "Forbrugsafregninger hvor betaling er mere end 300 DKK lavere end elforbrug baseret på ELOverblik.dk",
    "dashboard.deviation.empty": "Ingen rækker overstiger den negative afvigelsestærskel.",
    "dashboard.deviation.openOverview": "Åbn booking forbrugsoversigt",
    "dashboard.receivables.title": "Tilgodehavender",
    "dashboard.receivables.subtitle":
      "Antal og beløb for uafregnede tilgodehavender pr. kanal.",
    "dashboard.receivables.empty": "Ingen uafregnede tilgodehavender fundet.",
    "dashboard.receivables.count": "Antal",
    "dashboard.receivables.amount": "Beløb",
    "dashboard.receivables.openPage": "Åbn tilgodehavender",
    "dashboard.bank.title": "Banktransaktion opfølgning",
    "dashboard.bank.unsettledCount": "Uafregnede banktransaktioner: {count}",
    "dashboard.bank.latestImport": "Seneste import: {date}",
    "dashboard.bank.noImports": "Ingen banktransaktionsimport endnu.",
    "dashboard.bank.todoHint": "Der er transaktioner der venter på afregning.",
    "dashboard.bank.noTodo": "Ingen uafregnede transaktioner lige nu.",
    "dashboard.bank.openPage": "Åbn banktransaktioner",
    "dashboard.winterRule.title": "Vinterregel for benyttelse",
    "dashboard.winterRule.subtitle":
      "Bookede nætter i vinterperioden (31.10-28.02). Lovlig maksimumgrænse: 63 nætter pr. sæson.",
    "dashboard.winterRule.loading": "Indlæser vintersæson-forbrug...",
    "dashboard.winterRule.season": "Sæson {season}",
    "dashboard.winterRule.nightsUsed": "{booked} / {allowed} nætter booket",
    "dashboard.winterRule.exceeded": "Grænsen er overskredet med {count} nætter.",
    "dashboard.winterRule.remaining": "{count} nætter tilbage.",
    "dashboard.total": "I alt",
    "settings.createHouse": "Opret et nyt hus",
    "settings.languageLabel": "Vælg sprog",
    "settings.languageTitle": "Sprog",
    "settings.localeError": "Kunne ikke opdatere sprog. Prøv igen.",
    "settings.noHouses": "Ingen huse endnu",
    "settings.noHousesDescription": "Opret et hus for at komme i gang.",
    "stats.avgPricePerDay": "Gennemsnitlig pris pr. dag",
    "stats.avgStay": "Gennemsnitlig opholdslængde",
    "stats.bookedDays": "Bookede dage",
    "stats.bookings": "Bookinger",
    "stats.daysValue": "{days} dage",
    "stats.loadFailed": "Kunne ikke indlæse statistik",
    "stats.loading": "Indlæser statistik...",
    "stats.noChannelData": "Ingen kanaldata.",
    "stats.selectHouse": "Vælg et hus for at se statistik.",
    "stats.subtitle": "Overblik over bookingperformance og indtægter for det valgte år.",
    "stats.title": "Statistik",
    "stats.totalIncome": "Samlet indtægt",
    "stats.totalRentalIncome": "Samlet lejeindtægt",
    "stats.utilitiesIncome": "Forbrugsindtægter",
    "stats.utilitiesPerDay": "Forbrugsindtægt pr. dag",
    "channel.label.villavilla": "VillaVilla",
    "channel.description.villavilla": "Ejerside-bookinger og priskalender.",
    "channel.label.admiralstrand": "AdmiralStrand",
    "channel.description.admiralstrand": "Ejerøkonomi og bookingkalender.",
    "channel.label.eloverblik": "ElOverblik",
    "channel.description.eloverblik": "Elforbrug fra ElOverblik Customer API.",
    "status.unknown": "Ukendt",
    "status.booked": "Booket",
    "status.cancelled": "Annulleret",
    "status.external-booking": "Ekstern booking",
    "email.role.full": "fuld adgang",
    "email.role.readonly": "læseadgang",
    "email.invite.subject": "Du er inviteret til {houseName} i Hytteflow",
    "email.invite.body": "Du er inviteret til {houseName} med {role}.",
    "email.invite.instructions": "Opret eller log ind med {email}, og åbn derefter Hytteflow og acceptér invitationen.",
    "email.otp.reset": "Nulstil din Hytteflow-adgangskode",
    "email.otp.verify": "Bekræft din Hytteflow-e-mail",
    "email.otp.signIn": "Din Hytteflow-login-kode",
    "email.otp.code": "Din engangskode er: {otp}",
    "email.otp.ignore": "Hvis du ikke har anmodet om dette, kan du se bort fra denne e-mail.",
    "admin.accessDenied": "Adgang nægtet.",
    "admin.active": "Aktiv",
    "admin.activeHouses": "{count} aktive",
    "admin.bookingValue": "Bookingværdi {year}",
    "admin.bookingValueYtd": "Bookingværdi YTD",
    "admin.channels": "Kanaler",
    "admin.created": "Oprettet",
    "admin.email": "E-mail",
    "admin.houses": "Huse",
    "admin.housesMissingChannels": "Huse uden kanaler",
    "admin.housesSubtitle": "Kanalkonnektion og bookingværdi.",
    "admin.importActivity": "Importaktivitet",
    "admin.inactive": "Inaktiv",
    "admin.lastLogin": "Seneste login",
    "admin.loadFailed": "Kunne ikke indlæse admin-data",
    "admin.loading": "Indlæser admin-data...",
    "admin.noChannelCredentials": "Ingen aktive kanallegitimationsoplysninger.",
    "admin.noHouses": "Ingen huse tilgængelige.",
    "admin.noImports": "Ingen importer registreret endnu.",
    "admin.noUsers": "Ingen brugere tilgængelige.",
    "admin.recentJobs": "{count} job de sidste 7 dage.",
    "admin.status": "Status",
    "admin.subtitle": "Ejer-only overblik over systemaktivitet.",
    "admin.title": "Admin overblik",
    "admin.users": "Brugere",
    "admin.usersSubtitle": "Oprettelse af konti og loginaktivitet.",
    "admin.house": "Hus",
    "bankTransactions.removeLinkConfirm": "Fjern denne kobling og slet den tilknyttede postering? Dette kan ikke fortrydes."
  },
  en: {
    "environment.dev": "Dev",
    "environment.staging": "Staging",
    "entries.amountSignWarning": "Warning: The amount sign looks unusual for {account}. Continue anyway?",
    "entries.delete": "Delete journal entry",
    "entries.deleteConfirm": "Delete this journal entry? This cannot be undone.",
    "entries.deleteFailed": "Failed to delete journal entry",
    "nav.budgetWorksheet": "Budget",
    "nav.budgetWorksheetDescription": "Edit multi-year budgets in a grid.",
    "nav.dashboard": "Dashboard",
    "nav.dashboardDescription": "Quick overview of what needs attention.",
    "reports.actual": "Actual",
    "reports.actualYear": "Actual year",
    "reports.budgetWorksheetTitle": "Budget worksheet",
    "reports.budgetWorksheetSubtitle": "Edit four years of budgets and copy/paste with Excel.",
    "reports.budgetWorksheetSelectHouse": "Select a house to edit budgets.",
    "reports.budgetWorksheetLoadFailed": "Failed to load budget worksheet",
    "reports.budgetStartYear": "Start year",
    "reports.budgetWorksheetTableTitle": "Budget grid",
    "reports.budgetWorksheetPasteHint": "Paste a TSV block to fill cells.",
    "reports.copyTsv": "Copy as TSV",
    "reports.copyTsvSuccess": "Copied table to clipboard.",
    "reports.copyTsvFailed": "Failed to copy to clipboard.",
    "reports.saveBudget": "Save budget",
    "reports.savingBudget": "Saving...",
    "reports.budgetWorksheetSaved": "Budgets saved.",
    "reports.budgetWorksheetSaveFailed": "Failed to save budgets.",
    "reports.invalidBudgetInput": "Provide valid numbers before saving.",
    "reports.budgetReadonly": "Budgets are read-only for this house.",
    "bankTransactions.removeLinkConfirm": "Remove this link and delete the underlying journal entry? This cannot be undone.",
    "consumption.comparisonTable": "Booking comparison (Paid-for derived vs ElOverblik)",
    "consumption.comparisonMissingSetup":
      "Connect ElOverblik in Settings and choose a metering point to compare values.",
    "consumption.booking": "Booking",
    "consumption.meterKwh": "Meter (kWh)",
    "consumption.inferredKwh": "Inferred (kWh)",
    "consumption.paidForDerived": "Paid for",
    "consumption.eloverblikMeasured": "ElOverblik measured",
    "consumption.usagePerDay": "Usage/day",
    "consumption.eloverblikKwh": "ElOverblik (kWh)",
    "consumption.deviationPercent": "Deviation %",
    "consumption.deviationDkk": "Deviation DKK",
    "consumption.warning": "Warning",
    "consumption.warningOver20": "Over 20%",
    "consumption.warningOk": "OK",
    "consumption.noComparisonRows": "No booking-level comparison rows are available yet.",
    "consumption.inBetweenTable": "In-between periods (non-booked)",
    "consumption.noInBetweenRows": "No in-between periods found in selected range.",
    "channels.eloverblikTokenHelp":
      "Get your refresh token from Step 1 in the ElOverblik Customer guide and paste it here.",
    "channels.eloverblikGuide": "Open guide",
    "channels.eloverblikRefreshToken": "Refresh token",
    "channels.eloverblikFindMeteringPoints": "Find houses",
    "channels.eloverblikSaveSelection": "Save selection",
    "channels.eloverblikMeteringPoint": "Metering point",
    "channels.admiralstrandHouseId": "House ID",
    "meterReadings.inferredFromRevenue": "Inferred from utility revenue",
    "meterReadings.title": "Utility consumption overview",
    "meterReadings.subtitle":
      "Compare paid consumption with reported readings and ElOverblik.",
    "meterReadings.derivedUsage": "Paid-for derived usage",
    "meterReadings.paidForUsage": "Paid {dkk} DKK for usage {usage} {unit}",
    "meterReadings.derivedUsagePerDay": "Usage per day: {value} {unit}",
    "meterReadings.eloverblikUsage": "ElOverblik consumption: {value} kWh",
    "meterReadings.newMeterQuestion": "New meter installed?",
    "meterReadings.readingStart": "Reading start",
    "meterReadings.readingEnd": "Reading end",
    "meterReadings.calculatedSuffix": "(calculated)",
    "meterReadings.reportedReadings": "reported readings",
    "meterReadings.overviewTitle": "Booking consumption overview",
    "meterReadings.noOverviewRows": "No booking overview rows available.",
    "meterReadings.costDkk": "Cost (DKK)",
    "meterReadings.costPerDayDkk": "Cost/day (DKK)",
    "meterReadings.days": "Days",
    "meterReadings.total": "Total",
    "meterReadings.dayShort": "day",
    "meterReadings.reportedUsage": "Reported (m3)",
    "meterReadings.rawParsedReadings": "Raw parsed readings",
    "meterReadings.parsedStart": "Parsed reading start",
    "meterReadings.parsedEnd": "Parsed reading end",
    "meterReadings.derivedStart": "Derived start",
    "meterReadings.derivedEnd": "Derived end",
    "meterReadings.complaintTooltip": "Write complaint to agency",
    "meterReadings.complaintButtonTitle": "Write complaint",
    "meterReadings.complaintModalTitle": "Complaint email draft",
    "meterReadings.complaintChannelLabel": "Channel",
    "meterReadings.complaintStartDateLabel": "Start date",
    "meterReadings.complaintEndDateLabel": "End date",
    "meterReadings.complaintThresholdLabel": "Deviation threshold (DKK)",
    "meterReadings.complaintLanguageLabel": "Language",
    "meterReadings.complaintLanguageDanish": "Danish",
    "meterReadings.complaintLanguageEnglish": "English",
    "meterReadings.complaintIncludeCleaningReading": "Include \"rengøring kWh\" column.",
    "meterReadings.complaintSummary": "{count} bookings, total underpayment {amount} DKK",
    "dashboard.title": "Dashboard",
    "dashboard.subtitle": "Overview of integrations, bookings, receivables, and bank follow-up.",
    "dashboard.selectHouse": "Select a house to view the dashboard.",
    "dashboard.loading": "Loading dashboard...",
    "dashboard.loadFailed": "Failed to load dashboard",
    "dashboard.integration.title": "Integration health",
    "dashboard.integration.missing": "Missing setup for {count} channel(s).",
    "dashboard.integration.setupHint":
      "Open Settings, connect each missing channel, and run an import to initialize data.",
    "dashboard.integration.failed": "Last import failed for {count} channel(s).",
    "dashboard.integration.lastJob": "Job: {kind} at {time}",
    "dashboard.integration.unknownError": "Unknown import error.",
    "dashboard.integration.loading": "Loading integration health...",
    "dashboard.integration.openSettings": "Open settings",
    "dashboard.bookings.title": "Booked days and revenue by month",
    "dashboard.bookings.subtitle": "Booked days (left axis) and revenue DKK (right axis).",
    "dashboard.bookings.empty": "No booking data available for the selected year.",
    "dashboard.bookings.bookedDays": "Booked days",
    "dashboard.bookings.revenue": "Rental revenue DKK",
    "dashboard.deviation.title": "High consumption deviations",
    "dashboard.deviation.subtitle":
      "Consumption settlements where payment is more than 300 DKK lower than electricity consumption based on ElOverblik.dk.",
    "dashboard.deviation.empty": "No rows exceed the negative deviation threshold.",
    "dashboard.deviation.openOverview": "Open booking consumption overview",
    "dashboard.receivables.title": "Receivables",
    "dashboard.receivables.subtitle": "Count and amount of unsettled receivables per channel.",
    "dashboard.receivables.empty": "No unsettled receivables found.",
    "dashboard.receivables.count": "Count",
    "dashboard.receivables.amount": "Amount",
    "dashboard.receivables.openPage": "Open receivables",
    "receivables.outstandingTotal": "Outstanding total",
    "dashboard.bank.title": "Bank transaction follow-up",
    "dashboard.bank.unsettledCount": "Unsettled bank transactions: {count}",
    "dashboard.bank.latestImport": "Latest import: {date}",
    "dashboard.bank.noImports": "No bank transaction imports yet.",
    "dashboard.bank.todoHint": "There are transactions waiting to be settled.",
    "dashboard.bank.noTodo": "No unsettled transactions right now.",
    "dashboard.bank.openPage": "Open bank transactions",
    "dashboard.winterRule.title": "Winter usage rule",
    "dashboard.winterRule.subtitle":
      "Booked nights in the winter period (31.10-28.02). Legal maximum: 63 nights per season.",
    "dashboard.winterRule.loading": "Loading winter season usage...",
    "dashboard.winterRule.season": "Season {season}",
    "dashboard.winterRule.nightsUsed": "{booked} / {allowed} nights booked",
    "dashboard.winterRule.exceeded": "Limit exceeded by {count} nights.",
    "dashboard.winterRule.remaining": "{count} nights remaining.",
    "dashboard.total": "Total",
    "stats.bookedDays": "Booked days",
  },
};
